import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast } from 'antd-mobile';
import { Picker } from 'antd-mobile-v5';
import { withRouter } from 'react-router-dom';
import dayjs from 'dayjs';
import InputDialog from '../AlkComponent/inputDialog';
import styles from './survey.module.scss';
import blue_arrow_down from '../../static/images_ae/alkReport/blue_arrow_down.png';
import btn_six_side from '../../static/images_ae/alkReport/btn_six_side.png';
import survey_re_evaluation from '../../static/images_ae/alkReport/survey_re_evaluation.png';
import survey_btn from '../../static/images_ae/alkReport/survey_btn.png';
import survey_close from '../../static/images_ae/alkReport/survey_close.png';
import survey_edit from '../../static/images_ae/alkReport/survey_edit.png';

const api = new ApiCore();

const _q2 = [{
    name: '男性'
}, {
    name: '女性'
}, {
    name: '未知'
}, {
    name: '未说明'
}];

const _q3 = [{
    name: '非小细胞肺癌（腺癌、鳞癌、腺鳞癌）'
}, {
    name: '小细胞肺癌'
}, {
    name: '其他癌种'
}, {
    name: '尚未确诊'
}];

const _q4 = [{
    name: 'ALK'
}, {
    name: 'EGFR'
}, {
    name: 'ROS1'
}, {
    name: 'PD-1/PD-L1'
}, {
    name: '其他'
}];

const _q5 = [{
    name: '未确诊'
}, {
    name: '已确诊，暂未进行治疗'
}, {
    name: '已确诊，在手术过程中，尚未进行全身治疗'
}, {
    name: '正在进行全身治疗过程中'
}, {
    name: '治疗已完成，遵医嘱随访'
}, {
    name: '其他'
}];

const _q6 = [{
    name: '化疗'
}, {
    name: '放疗'
}, {
    name: '靶向治疗'
}, {
    name: '免疫治疗'
}, {
    name: '手术治疗'
}, {
    name: '当前未接受治疗'
}, {
    name: '其他'
}];

const _q7 = [{
    name: '心血管疾病',
    desc: '（高血压、冠心病、心律失常、脑卒中等）'
}, {
    name: '慢性肝病',
    desc: '（乙肝、丙肝、脂肪肝等）'
}, {
    name: '代谢性疾病',
    desc: '（糖尿病、高血脂等）'
}, {
    name: '精神疾病',
    desc: '（癫痫、抑郁症、焦虑症、认知障碍、记忆障碍等）'
}, {
    name: '未患有其他疾病',
    desc: ''
}, {
    name: '其他',
    desc: ''
}];

const _q8 = [{
    name: '0分',
    desc: '活动能力完全正常，与起病前活动能力无任何差异'
}, {
    name: '1分',
    desc: '能自由走动及从事轻体力活动，包括一般事务或办公室工作，但不能重试较重的体力活动'
}, {
    name: '2分',
    desc: '能自由走动及生活自理，但已丧失工作能力，日间不少于一半日间时间可以起床活动'
}, {
    name: '3分',
    desc: '生活仅能部分自理，日间一半以上时间卧床或坐轮椅'
}, {
    name: '4分',
    desc: '卧床不起，生活不能自理'
}];

const Survey = (props: any) => {

    const [selectedCount, setSelectedCount] = useState<number>(0)
    const [selectedCompleted, setSelectedCompleted] = useState<boolean>(false)
    const [notDiagnose, setNotDiagnose] = useState<boolean>(false) // 尚未确诊，只需要选择前三题
    const [selectedQ1, setSelectedQ1] = useState<boolean>(false)
    const [selectedQ2, setSelectedQ2] = useState<boolean>(false)
    const [selectedQ3, setSelectedQ3] = useState<boolean>(false)
    const [selectedQ4, setSelectedQ4] = useState<boolean>(false)
    const [selectedQ5, setSelectedQ5] = useState<boolean>(false)
    const [selectedQ6, setSelectedQ6] = useState<boolean>(false)
    const [selectedQ7, setSelectedQ7] = useState<boolean>(false)
    const [selectedQ8, setSelectedQ8] = useState<boolean>(false)
    const [isHealthy, setIsHealthy] = useState<boolean>(false)
    const [groupColumns, setGroupColumns] = useState<any>([])
    const [groupList, setGroupList] = useState<any>([])
    const [selectGroup, setSelectGroup] = useState<any>(null)
    const [selectListGroup, setSelectListGroup] = useState<any>({})
    const [q1, setQ1] = useState<any>([])
    const [q2, setQ2] = useState<any>(_q2)
    const [q3, setQ3] = useState<any>(_q3)
    const [q4, setQ4] = useState<any>(_q4)
    const [q5, setQ5] = useState<any>(_q5)
    const [q6, setQ6] = useState<any>(_q6)
    const [q7, setQ7] = useState<any>(_q7)
    const [q8, setQ8] = useState<any>(_q8)
    const [expandAll, setExpandAll] = useState<boolean>(false)
    const [otherDialogContent, setOtherDialogContent] = useState<string>('')
    const [otherDialogPlaceholder, setOtherDialogPlaceholder] = useState<string>('')
    const [activeQIndex, setActiveQIndex] = useState<any>(-1)
    const [showOtherDialog, setShowOtherDialog] = useState<boolean>(false)

    useEffect(() => {
        initSavedData();
        initData();
        return () => {
        }
    }, [])

    useEffect(() => {
        if (notDiagnose) {
            if (selectedQ1 && selectedQ2 && selectedQ3) {
                setSelectedCompleted(true);
            } else {
                setSelectedCompleted(false);
            }
        } else if ([selectedQ1, selectedQ2, selectedQ3, selectedQ4].every((v: any) => v)) {
            //  selectedQ5, selectedQ6, selectedQ7, selectedQ8].every((v: any) => v)) {
                setSelectedCompleted(true);
        } else {
            setSelectedCompleted(false);
        }
    }, [selectedQ1, selectedQ2, selectedQ3, selectedQ4, notDiagnose])
    // }, [selectedQ1, selectedQ2, selectedQ3, selectedQ4, selectedQ5, selectedQ6, selectedQ7, selectedQ8, notDiagnose])
    
    useEffect(() => {
        updateSavedData();
    }, [selectGroup, q2, q3, q4, q5, q6, q7, q8, selectedQ1, selectedQ2, selectedQ3, selectedQ4, selectedQ5, selectedQ6, selectedQ7, selectedQ8, notDiagnose, selectedCompleted, expandAll])

    // 重新填写时更新
    const initSavedData = () => {
        const savedData = localStorage.getItem('alk_report_saved_data');
        if (savedData) {
            let savedItem = JSON.parse(savedData);
            let nowDate = new Date().getTime();
            let beforeDate = new Date(savedItem.date).getTime();
            const gapDays = (nowDate - beforeDate) /  (24 * 60 * 60 * 1000);
            // 7天内有效
            if (gapDays <= 7) {
                const surveyData = savedItem.survey;
                setSelectGroup(surveyData.selectGroup);
                setQ2(surveyData.q2);
                setQ3(surveyData.q3);
                setQ4(surveyData.q4);
                setQ5(surveyData.q5);
                setQ6(surveyData.q6);
                setQ7(surveyData.q7);
                setQ8(surveyData.q8);
                setSelectedQ1(surveyData.selectedQ1);
                setSelectedQ2(surveyData.selectedQ2);
                setSelectedQ3(surveyData.selectedQ3);
                setSelectedQ4(surveyData.selectedQ4);
                setSelectedQ5(surveyData.selectedQ5);
                setSelectedQ6(surveyData.selectedQ6);
                setSelectedQ7(surveyData.selectedQ7);
                setSelectedQ8(surveyData.selectedQ8);
                setSelectedCompleted(surveyData.selectedCompleted);
                setNotDiagnose(surveyData.notDiagnose);
                setExpandAll(surveyData.expandAll);
            } else {
                // 7天后失效
                localStorage.removeItem('alk_report_saved_data')
            }
        } else {
            setTimeout(() => {
                // 清除页面初始化时存的数据
                localStorage.removeItem('alk_report_saved_data');
            }, 500);
        }
    }

    // 更新缓存
    const updateSavedData = () => {
        let savedItemBefore = {};
        let saved_data = localStorage.getItem('alk_report_saved_data');
        if (saved_data) {
            savedItemBefore = JSON.parse(saved_data);
        }
        const savedItem = {
            ...savedItemBefore,
            date: dayjs(new Date()).format('YYYY-MM-DD'), // 存储已填过的信息，一个月过期。
            survey: {
                selectGroup: selectGroup,
                q2: q2,
                q3: q3,
                q4: q4,
                q5: q5,
                q6: q6,
                q7: q7,
                q8: q8,
                selectedQ1: selectedQ1,
                selectedQ2: selectedQ2,
                selectedQ3: selectedQ3,
                selectedQ4: selectedQ4,
                selectedQ5: selectedQ5,
                selectedQ6: selectedQ6,
                selectedQ7: selectedQ7,
                selectedQ8: selectedQ8,
                selectedCompleted: selectedCompleted,
                notDiagnose: notDiagnose,
                expandAll: expandAll
            }
        }
        localStorage.setItem('alk_report_saved_data', JSON.stringify(savedItem));
    }

    const initData = () => {
        const _data: any =  [
            {name: '<20', code: '<20'},
            {name: '20-30', code: '20-30'},
            {name: '31-40', code: '31-40'},
            {name: '41-50', code: '41-50'}, 
            {name: '51-60', code: '51-60'}, 
            {name: '61-70', code: '61-70'}, 
            {name: '71-80', code: '71-80'},
            {name: '>80', code: '>80'}
        ]
        const groupColumns: any = _data.map((item: any) => {
            return {
                label: item.name,
                value: item.code
            }
        })
        setGroupColumns(groupColumns);
        setGroupList(_data);
    }

    const toNext = () => {
        if (!selectedCompleted) {
            Toast.show('请先完成全部问题', 0.8);
        } else {
            if (notDiagnose == false) {
                const investigation = {
                    "age": selectGroup.value,
                    "sex": q2.filter((v: any) => v.selected).map((vv: any) => vv.name).toString(),
                    "cancerType": q3.filter((v: any) => v.selected).map((vv: any) => vv.name).toString(),
                    "detectionType": q4.filter((v: any) => v.selected).map((vv: any) => vv.name).toString(),
                    "otherDetectionType": "",
                    "treatmentStage": q5.filter((v: any) => v.selected).map((vv: any) => vv.name).toString(),
                    "otherTreatmentStage": "",
                    "treatments": q6.filter((v: any) => v.selected).map((vv: any) => vv.name).join(';'),
                    "otherTreatment": '',
                    "diseases": q7.filter((v: any) => v.selected).map((vv: any) => (vv.name + (vv.desc || ''))).join(';'),
                    "otherDiseases": '',
                    "ps": q8.filter((v: any) => v.selected).map((vv: any) => (vv.name + '：' + (vv.desc || ''))).toString(),
                }
                let savedItemBefore = {};
                let saved_data = localStorage.getItem('alk_report_saved_data');
                if (saved_data) {
                    savedItemBefore = JSON.parse(saved_data);
                }
                const savedItem = {
                    ...savedItemBefore,
                    nowStep: 2,
                    investigation: investigation
                }
                localStorage.setItem('alk_report_saved_data', JSON.stringify(savedItem));
                props.investigationComplete(investigation);
            } else {
                setIsHealthy(true);
            }
        }
    }

    const itemSelected = (v: number, k: number, options: {
        singleSelected: boolean,
        canbeCanced: boolean,
        targetList: any
    }) => {
        const item = options.targetList.map((vv: any, kk: number) => {
            let selected = vv.selected;
            if (kk == k) {
                // 可以选中后取消
                if (options.canbeCanced) {
                    selected = !selected
                } else {
                    selected = true;
                }
            } else {
                if (options.singleSelected) {
                    // 单选
                    selected = false;
                }
            }
            return {
                ...vv,
                selected
            }
        });
        return item;
    }

    const q2Selected = (v: any, k: number) => {
        // const __q2 = q2.map((vv: any, kk: number) => {
        //     let selected = vv.selected;
        //     if (kk == k) {
        //         selected = !selected
        //     } else {
        //         // 单选
        //         selected = false;
        //     }
        //     return {
        //         ...vv,
        //         selected
        //     }
        // })
        const __q2 = itemSelected(v, k, {
            singleSelected: true,
            canbeCanced: false,
            targetList: q2
        });
        setQ2(__q2);
        setSelectedQ2(true);
    }

    const q3Selected = (v: any, k: number) => {
        const __q3 = itemSelected(v, k, {
            singleSelected: true,
            canbeCanced: false,
            targetList: q3
        });
        setQ3(__q3);
        if (k !== (q3.length -1)) {
            setNotDiagnose(false);
            setExpandAll(true);
        } else {
            // 选择尚未确诊
            setNotDiagnose(true);
            setExpandAll(false);
        }
        setSelectedQ3(true);
    }

    const q4Selected = (v: any, k: number) => {
        if (v.name == '其他') {
            setActiveQIndex(4);
            toShowOtherDialog('请在此处输入您要补充的基因靶点检测结果......');
            return;
        }
        const __q4 = itemSelected(v, k, {
            singleSelected: true,
            canbeCanced: false,
            targetList: q4
        });
        setQ4(__q4);
        setSelectedQ4(true);
    }

    const q5Selected = (v: any, k: number) => {
        if (v.name == '其他') {
            setActiveQIndex(5);
            toShowOtherDialog('请在此处输入您要补充的治疗阶段......');
            return;
        }
        const __q5 = itemSelected(v, k, {
            singleSelected: true,
            canbeCanced: false,
            targetList: q5
        });
        setQ5(__q5);
        setSelectedQ5(true);
    }

    const q6Selected = (v: any, k: number) => {
        if (v.name == '其他') {
            setActiveQIndex(6);
            toShowOtherDialog('请在此处输入您要补充的治疗方案......');
            return;
        }
        const __q6 = itemSelected(v, k, {
            singleSelected: false,
            canbeCanced: true,
            targetList: q6
        });
        setQ6(__q6);
        // 因为是多选，需要检测有没有选择完全
        const _q6HasSelected = __q6.some((vv: any) => vv.selected);
        setSelectedQ6(_q6HasSelected);
    }

    const q7Selected = (v: any, k: number) => {
        if (v.name == '其他') {
            setActiveQIndex(7);
            toShowOtherDialog('请在此处输入您要补充合并患有的其他疾病......');
            return;
        }
        let singleSelected = false;
        if (v.name == '未患有其他疾病' && !v.selected) {
            singleSelected = true;
        }
        const __q7 = itemSelected(v, k, {
            singleSelected: singleSelected,
            canbeCanced: true,
            targetList: q7
        });
        setQ7(__q7);
        // 因为是多选，需要检测有没有选择完全
        const _q7HasSelected = __q7.some((vv: any) => vv.selected);
        setSelectedQ7(_q7HasSelected);
    }

    const q8Selected = (v: any, k: number) => {
        const __q8 = itemSelected(v, k, {
            singleSelected: true,
            canbeCanced: false,
            targetList: q8
        });
        setQ8(__q8);
        setSelectedQ8(true);
    }
    
    const reRvaluation = () => {
        setSelectedQ1(false);
        setSelectedQ2(false);
        setSelectedQ3(false);
        setSelectedQ4(false);
        setSelectedQ5(false);
        setSelectedQ6(false);
        setSelectedQ7(false);
        setSelectedQ8(false);
        setSelectGroup(null);
        setSelectListGroup([]);
        setQ1([])
        setQ2(_q2)
        setQ3(_q3)
        setQ4(_q4)
        setQ5(_q5)
        setQ6(_q6)
        setQ7(_q7)
        setQ8(_q8)
        setIsHealthy(false);
        setTimeout(() => {
            // 重新评估后清除数据
            localStorage.removeItem('alk_report_saved_data');
        }, 500);
    }

    const onClose = () => {
        setOtherDialogContent('');
        setOtherDialogPlaceholder('');
        setShowOtherDialog(false);
        setActiveQIndex(-1);
    }

    const onSave = (value: any) => {
        setOtherDialogContent(value);
        setOtherDialogPlaceholder('');
        toCompleteValue(value);
        setShowOtherDialog(false);
        setActiveQIndex(-1);
    }

    const toShowOtherDialog = (placeholder: string) => {
        setOtherDialogPlaceholder(placeholder);
        setShowOtherDialog(true);
    }

    const toCompleteValue = (value: any) => {
        if (activeQIndex == 4) {
            const mQ4 = q4.map((v: any) => ({ ...v, selected: false}));
            const item = mQ4[mQ4.length - 2];
            // 已经填过
            if (item.type == 'addedByOther') {
                mQ4[mQ4.length - 2].name = value;
                mQ4[mQ4.length - 2].selected = true;
            } else {
                mQ4.pop();
                mQ4.push({
                    name: value,
                    selected: true,
                    type: 'addedByOther'
                });
                mQ4.push({
                    name: '其他'
                });
            }
            setQ4(mQ4);
            setSelectedQ4(true);
        } else if (activeQIndex == 5) {
            const targetList = q5.map((v: any) => ({ ...v, selected: false}));
            const item = targetList[targetList.length - 2];
            // 已经填过
            if (item.type == 'addedByOther') {
                targetList[targetList.length - 2].name = value;
                targetList[targetList.length - 2].selected = true;
            } else {
                targetList.pop();
                targetList.push({
                    name: value,
                    selected: true,
                    type: 'addedByOther'
                });
                targetList.push({
                    name: '其他'
                });
            }
            setQ5(targetList);
            setSelectedQ5(true);
        } else if (activeQIndex == 6) {
            const targetList = q6.map((v: any) => ({ ...v}));
            const item = targetList[targetList.length - 2];
            // 已经填过
            if (item.type == 'addedByOther') {
                targetList[targetList.length - 2].name = value;
                targetList[targetList.length - 2].selected = true;
            } else {
                targetList.pop();
                targetList.push({
                    name: value,
                    selected: true,
                    type: 'addedByOther'
                });
                targetList.push({
                    name: '其他'
                });
            }
            setQ6(targetList);
            setSelectedQ6(true);
        } else if (activeQIndex == 7) {
            const targetList = q7.map((v: any) => ({ ...v}));
            const item = targetList[targetList.length - 2];
            // 已经填过
            if (item.type == 'addedByOther') {
                targetList[targetList.length - 2].name = value;
                targetList[targetList.length - 2].selected = true;
            } else {
                targetList.pop();
                targetList.push({
                    name: value,
                    selected: true,
                    type: 'addedByOther'
                });
                targetList.push({
                    name: '其他'
                });
            }
            setQ7(targetList);
            setSelectedQ7(true);
        }
    }


    return (
        <div className={styles.alk_sruvey}>
            {
                !isHealthy && 
            <>
            <div className={styles.alk_outer}>
                <div className={styles.title}>
                    1、您的年龄（岁）：
                </div>
                <div className={styles.content_wrap}>
                    <div className={styles.content}
                        onClick={async () => {
                            const value = await Picker.prompt({
                                defaultValue: [groupColumns[4].value],
                                columns: [groupColumns],
                            })
                            const index = groupColumns.findIndex((v: any) => v.value == value?.toString());
                            if (index > -1) {
                                setSelectGroup(groupColumns[index])
                                setSelectListGroup(groupList[index])
                                setSelectedQ1(true);
                            }
                        }}
                    >
                        
                        <span style={{color: `${selectGroup ? 'rgba(82, 39, 157, 1)' : 'rgba(82, 39, 157, 0.5)'}`}}>{selectGroup ? selectGroup?.value : '请选择您的年龄'}</span>
                        <img className={styles.blue_arrow_down} src={blue_arrow_down} alt="" />
                    </div>
                </div>
                <div
                    className={styles.bottom}
                >
                </div>
            </div>
            <div className={styles.alk_outer}>
                <div className={styles.title}>
                    2、您的性别：
                </div>
                <div className={`${styles.content_wrap} ${styles.content_wrap_expand2}`}>
                    {
                        q2 && q2.map((v: any, k: number) =>(
                        <div key={k} className={`${styles.base_item} ${styles.db_item} ${v.selected ? styles.active : styles.un_active}`}
                            onClick={() => { q2Selected(v, k) }}
                        >
                            {v.name}
                        </div> 
                        ))
                    }
                    {/* <div className={`${styles.base_item} ${styles.db_item} ${styles.active}`}
                    >
                         男性
                    </div>
                    <div className={`${styles.base_item} ${styles.db_item} ${styles.un_active}`}
                    >
                        女性
                    </div>
                    <div className={`${styles.base_item} ${styles.db_item} ${styles.un_active}`}
                    >
                        未知
                    </div>
                    <div className={`${styles.base_item} ${styles.db_item} ${styles.un_active}`}
                    >
                        未说明
                    </div> */}
                </div>
                <div
                    className={styles.bottom}
                >
                </div>
            </div>
            <div className={styles.alk_outer}>
                <div className={styles.title}>
                    3、您现在所患肺癌病例类型是？
                </div>
                <div className={`${styles.content_wrap} ${styles.content_wrap_expand3}`}>
                    {
                        q3 && q3.map((v: any, k: number) =>(
                        <div key={k} className={`${styles.base_item} ${k == 0 ? styles.single_item : styles.db_item} ${v.selected ? styles.active : styles.un_active}`}
                            onClick={() => { q3Selected(v, k) }}
                        >
                            {v.name}
                        </div> 
                        ))
                    }
                    {/* <div className={`${styles.base_item} ${styles.single_item} ${styles.active}`}
                    >
                         非小细胞肺癌（腺癌、鳞癌、腺鳞癌）
                    </div>
                    <div className={`${styles.base_item} ${styles.db_item} ${styles.un_active}`}
                    >
                        小细胞癌
                    </div>
                    <div className={`${styles.base_item} ${styles.db_item} ${styles.un_active}`}
                    >
                        其他癌种
                    </div>
                    <div className={`${styles.base_item} ${styles.db_item} ${styles.un_active}`}
                    >
                        尚未确诊
                    </div> */}
                </div>
                <div
                    className={styles.bottom}
                >
                </div>
            </div>
            {
                expandAll && 
                <>
                    <div className={styles.alk_outer}>
                        <div className={styles.title}>
                            4、您现在基因靶点检测为阳性结果的是？
                        </div>
                        <div className={`${styles.content_wrap} ${styles.content_wrap_expand4}`}>
                            {
                                q4 && q4.map((v: any, k: number) =>(
                                <div key={k} className={`${styles.base_item} ${styles.db_item} ${v.selected ? styles.active : styles.un_active}`}
                                    onClick={() => { q4Selected(v, k) }}
                                >
                                    {v.name}
                                </div> 
                                ))
                            }
                            {/* <div className={`${styles.base_item} ${styles.db_item} ${styles.active}`}
                            >
                                ALK
                            </div>
                            <div className={`${styles.base_item} ${styles.db_item} ${styles.un_active}`}
                            >
                                EGFR
                            </div>
                            <div className={`${styles.base_item} ${styles.db_item} ${styles.un_active}`}
                            >
                                ROS1
                            </div>
                            <div className={`${styles.base_item} ${styles.db_item} ${styles.un_active}`}
                            >
                                PD-1/PD-L1
                            </div>
                            <div className={`${styles.base_item} ${styles.db_item} ${styles.un_active}`}
                            >
                                其他
                            </div> */}
                        </div>
                        <div
                            className={styles.bottom}
                        >
                        </div>
                    </div>
                    <div className={styles.alk_outer}>
                        <div className={styles.title}>
                            5、您目前的治疗阶段是？（选填）
                        </div>
                        <div className={`${styles.content_wrap} ${q5.length === 7 ? styles.content_wrap_expand5_more : styles.content_wrap_expand5}`}>
                            {
                                q5 && q5.map((v: any, k: number) =>(
                                <div key={k} className={`${styles.base_item} ${styles.single_item} ${v.selected ? styles.active : styles.un_active}`}
                                    onClick={() => { q5Selected(v, k) }}
                                >
                                    {v.name}
                                </div> 
                                ))
                            }
                            {/* <div className={`${styles.base_item} ${styles.single_item} ${styles.active}`}
                            >
                                未确诊
                            </div>
                            <div className={`${styles.base_item} ${styles.single_item} ${styles.un_active}`}
                            >
                                已确诊，暂未进行治疗
                            </div>
                            <div className={`${styles.base_item} ${styles.single_item} ${styles.un_active}`}
                            >
                                已确诊，在手术过程中，尚未进行全身治疗
                            </div>
                            <div className={`${styles.base_item} ${styles.single_item} ${styles.un_active}`}
                            >
                            正在进行全身治疗过程中
                            </div>
                            <div className={`${styles.base_item} ${styles.single_item} ${styles.un_active}`}
                            >
                                其他
                            </div> */}
                        </div>
                        <div
                            className={styles.bottom}
                        >
                        </div>
                    </div>
                    <div className={styles.alk_outer}>
                        <div className={styles.title}>
                            6、您目前的治疗方案是？（可多选）（选填）
                        </div>
                        <div className={`${styles.content_wrap} ${styles.content_wrap_expand6}`}>
                            {
                                q6 && q6.map((v: any, k: number) =>(
                                <div key={k} className={`${styles.base_item} ${styles.db_item} ${v.selected ? styles.active : styles.un_active}`}
                                    onClick={() => { q6Selected(v, k) }}
                                >
                                    {v.name}
                                </div> 
                                ))
                            }
                            {/* <div className={`${styles.base_item} ${styles.db_item} ${styles.active}`}
                            >
                                化疗
                            </div>
                            <div className={`${styles.base_item} ${styles.db_item} ${styles.un_active}`}
                            >
                                放疗
                            </div>
                            <div className={`${styles.base_item} ${styles.db_item} ${styles.un_active}`}
                            >
                                靶向治疗
                            </div>
                            <div className={`${styles.base_item} ${styles.db_item} ${styles.un_active}`}
                            >
                            免疫治疗
                            </div>
                            <div className={`${styles.base_item} ${styles.db_item} ${styles.un_active}`}
                            >
                                手术治疗
                            </div>
                            <div className={`${styles.base_item} ${styles.db_item} ${styles.un_active}`}
                            >
                                当前未接收治疗
                            </div>
                            <div className={`${styles.base_item} ${styles.db_item} ${styles.un_active}`}
                            >
                                其他
                            </div> */}
                        </div>
                        <div
                            className={styles.bottom}
                        >
                        </div>
                    </div>
                    <div className={styles.alk_outer}>
                        <div className={styles.title}>
                            7、您在进行癌症全身治疗之前是否合并患有其他疾病？（可多选）（选填）
                        </div>
                        <div className={`${styles.content_wrap}  ${q7.length === 6 ? styles.content_wrap_expand7 : styles.content_wrap_expand7_more}`}>
                            {
                                q7 && q7.map((v: any, k: number) =>(
                                <div key={k} className={`${styles.base_item} ${k == 3 ? styles.line_2_height : ''} ${styles.single_item} ${v.selected ? styles.active : styles.un_active}`}
                                    onClick={() => { q7Selected(v, k) }}
                                >
                                    {/* <span className={`${styles.item_title} ${styles.item_title_inline}`} style={{fontWeight: k == q7.length - 1 ? 'normal': 'bold'}}>{v.name}</span>
                                    <span className={styles.item_desc}>{v.desc}</span> */}
                                    {
                                        k !== q7.length - 1 && 
                                        <span className={styles.item_desc_q7}>
                                            <span className={`${styles.item_title} ${styles.item_title_inline_q7}`}>{v.name}</span>
                                            {v.desc}
                                        </span>
                                    }
                                    {
                                        k == q7.length - 1 && 
                                        <>
                                         <span className={styles.item_desc}>
                                            <span className={`${styles.item_title_inline}`} style={{fontWeight: k == q7.length - 1 ? 'normal': 'bold', fontSize: k == q7.length - 1 ? '15px' : '' }} >{v.name}</span>
                                            {v.desc}
                                        </span>
                                        </>
                                    }
                                </div> 
                                ))
                            }
                            {/* <div className={`${styles.base_item} ${styles.single_item} ${styles.active}`}
                            >
                                <span className={styles.item_title}>心血管病</span>
                                <span className={styles.item_desc}>（高血压、冠心病、心律失常、脑卒中等）</span>
                            </div>
                            <div className={`${styles.base_item} ${styles.single_item} ${styles.un_active}`}
                            >
                                <span className={styles.item_title}>慢性肝病</span>
                                <span className={styles.item_desc}>（乙肝、丙肝、脂肪肝等）</span>
                            </div>
                            <div className={`${styles.base_item} ${styles.single_item} ${styles.un_active}`}
                            >
                                <span className={styles.item_title}>代谢性疾病</span>
                                <span className={styles.item_desc}>（糖尿病、高血脂等）</span>
                            </div>
                            <div className={`${styles.base_item} ${styles.single_item} ${styles.un_active}`}
                            >
                                <span className={`${styles.item_title} ${styles.item_title_inline}`}>精神疾病</span>
                                <span className={styles.item_desc}>（癫痫、抑郁症、焦虑症、认知障碍、记忆障碍等）</span>
                            </div>
                            <div className={`${styles.base_item} ${styles.single_item} ${styles.un_active}`}
                            >
                                其他
                            </div> */}
                        </div>
                        <div
                            className={styles.bottom}
                        >
                        </div>
                    </div>
                    <div className={styles.alk_outer}>
                        <div className={styles.title}>
                            8、您目前一般状态（PS）评分：（选填）
                        </div>
                        <div className={`${styles.content_wrap} ${styles.content_wrap_expand8}`}>
                            {
                                q8 && q8.map((v: any, k: number) =>(
                                <div key={k} className={`${styles.base_item}  ${(k == 1 || k == 2 ) ? styles.line_2_height : ''}  ${styles.single_item} ${v.selected ? styles.active : styles.un_active}`}
                                    onClick={() => { q8Selected(v, k) }}
                                >
                                    <span className={styles.item_desc}>
                                        <span className={`${styles.item_title} ${styles.item_title_inline}`}>{v.name}</span>
                                        {v.desc}
                                    </span>
                                </div> 
                                ))
                            }
                            {/* <div className={`${styles.base_item} ${styles.single_item} ${styles.active}`}
                            >
                                <span className={styles.item_title}>0分</span>
                                <span className={styles.item_desc}>（活动能力完全正常，与起病前活动能力无任何差异。）</span>
                            </div>
                            <div className={`${styles.base_item} ${styles.single_item} ${styles.un_active}`}
                            >
                                <span className={`${styles.item_title} ${styles.item_title_inline}`}>1分</span>
                                <span className={styles.item_desc}>能自由走动及从事轻体力活动，包括一般事务或办公室工作，但不能重试较重的体力活动。</span>
                            </div>
                            <div className={`${styles.base_item} ${styles.single_item} ${styles.un_active}`}
                            >
                                <span className={`${styles.item_title} ${styles.item_title_inline}`}>2分</span>
                                <span className={styles.item_desc}>能自由走动及生活自理，但已丧失工作能力，日间不少于一半日间时间可以起床活动</span>
                            </div>
                            <div className={`${styles.base_item} ${styles.single_item} ${styles.un_active}`}
                            >
                                <span className={`${styles.item_title} ${styles.item_title_inline}`}>3分</span>
                                <span className={styles.item_desc}>生活仅能部分自理，日间一半以上时间卧床或坐轮椅</span>
                            </div>
                            <div className={`${styles.base_item} ${styles.single_item} ${styles.un_active}`}
                            >
                                <span className={`${styles.item_title} ${styles.item_title_inline}`}>4分</span>
                                <span className={styles.item_desc}>卧床不起，生活不能自理</span>
                            </div> */}
                        </div>
                        <div
                            className={styles.bottom}
                        >
                        </div>
                    </div>

                </>
            }
            <div className={styles.tip_bottom_wrap} style={{ opacity: !selectedCompleted ? 0.5 : 1 }} onClick={toNext}>
                    <img className={styles.bootom_top} src={btn_six_side} alt="" />
                    <div className={styles.bootom_top_text}>
                    {
                        !selectedCompleted
                        ?
                        '请先完成全部问题'
                        :
                        `选择完成，进入下一步`
                    }
                    </div>
            </div>
            <div className={styles.tip_bottom_exit} onClick={() => { props.history.go(-1); }}>
                退出评估
            </div>
            </>
            }
            {
                isHealthy &&
                <div className={styles.health}>
                    <div className={styles.content}>
                        <img src={survey_re_evaluation} alt="" />
                    </div>
                    <div className={styles.btns}>
                        <div className={styles.btn1}  onClick={() => { props.history.go(-1); }}>
                            <img src={survey_close} alt="" />
                            <span>关闭</span>
                        </div>
                        <div className={styles.btn2}  onClick={() => { reRvaluation() }}>
                            <img src={survey_edit} alt="" />
                            <span>重新评估</span>
                        </div>
                    </div>
                </div>
            }
            {
                showOtherDialog &&
                <InputDialog onClose={onClose} onSave={onSave} placeholder={otherDialogPlaceholder}  />
            }
        </div>
    )
}

export default withRouter(Survey);